import {takeLatest} from 'redux-saga/effects';

import {getPubPostsSaga} from './getPubPosts/saga';
import {getPubPostsACS, updatePostACS} from './requestAC';
import {updatePostSaga} from './updatePost/saga';

export function* postsSaga() {
  yield takeLatest(getPubPostsACS.type, getPubPostsSaga);
  yield takeLatest(updatePostACS.type, updatePostSaga);
}
